<template>
  <div id="order-menu">

    <div id="under-order-breadcrumb"><keep-alive>
      <estimate-paper v-if="sizes.length && activeOrderStep=='estimate'" :sizes="sizes" @packInput="packInput">
        <div class="footer">
          <div class="footer-container">
            <div class="total_price">合計 {{totalPrice() | currency}}.-(税別)</div>
            <!--<vk-button class="next-button" :class="{disabled:notEnoughEstimate}" @click="changeOrder">カートに入れる</vk-button>-->
            <vk-button class="next-button" :class="{disabled:notEnoughEstimate}" @click="addCart">カートに入れる</vk-button>
          </div>
        </div>
      </estimate-paper>
    </keep-alive></div>

    <vk-modal :show.sync="modalShow" class="uk-modal uk-modal-body" :class="{'uk-open':modalShow}">
      <vk-modal-title>カートに入れました。</vk-modal-title>
      <div class="body">
        <button @click="modalShow = false;$router.push({path:'/cart'})" class="uk-margin-small-right">カートを見る</button>
        <button @click="modalShow = false;$router.push({name:'category'})" class="uk-margin-small-right">他のデザインを作る（TOPへ）</button>
      </div>
    </vk-modal>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex'
  import EstimatePaper from './item/EstimatePaper.vue'

  export default {
    name: 'order-menu',
    components: {
      EstimatePaper,
    },
    data(){
      return {
        sizes: [],
        activeOrderStep: 'estimate', // estimate - order - confirm - done
        notEnoughOrder: (this.$store.state.cart.order.email && this.$store.state.cart.order.name) ? false : true,
        modalShow: false
      }
    },
    computed: {
      ...mapState(['active_tab', 'cart']),
      ...mapGetters(['totalPrice']),
      notEnoughEstimate(){
        return !(this.cart.packs[0].size_id && this.cart.packs[0].value);
      }
    },
    methods: {
      ...mapActions([
        'selected_category',
        'selected_figure',
        'selected_design',
        'selected_color'
      ]),
      changeEstimate(){
        this.activeOrderStep = 'estimate';
      },
      changeOrder(){
        if (this.notEnoughEstimate) return;
        this.activeOrderStep = 'order';
        this.$emit('setMarquee', '');
      },
      addCart(){
        if (this.notEnoughEstimate) return;
        this.modalShow = true;
        this.$store.commit('addCart', this.$store.state.cart);
      },
      changeConfirm(){
        if (this.notEnoughOrder) return;
        this.activeOrderStep = 'confirm';
      },
      changeDone(){
        this.activeOrderStep = 'done';
      },
      packInput(){
      },
      orderInput(){
        this.notEnoughOrder = false;
      },
    },
    created(){
      if (!this.cart.figure) {
        this.$router.push({name: 'category'});
      }
      this.$emit('setMarquee', 'ご希望のサイズと数量を入力してください');
      if (this.notEnoughEstimate){
        this.activeOrderStep = 'estimate';
      }
      this.sizes = [];
      this.$store.commit('setLoading');
      window.axios.get('/sizes.json', {params: {figure_id: this.cart.figure.id}})
        .then(response => {
          this.sizes = response.data.sizes;
          this.$store.commit('setSizes', response.data.sizes);
          this.$store.commit('resetLoading');
        });
    },
  }
</script>

<style lang="scss" scoped>
  #order-menu {
    background-color: #fff;
  }
  .breadcrumb {
    background-color: #151d66;
  }

  .add_card {
    background-color: #9cc;
    width: 100%;
  }
  .arrow_box{
    display: inline-block;
    position: relative;
    background-color: #151d66;
    border: 1px solid white;
    margin: 4px;
    height: 39px;
  }
  .arrow_box > button {
    background-color: rgb(54,62,110);
    margin-left: 4px;
  }
  .arrow_box:after{
    position: absolute;
    content: "";
    border: 1px solid transparent;
    display: inline-block;
    border-width: 20px 0px 20px 20px;
    border-color: transparent transparent transparent #151d66;
  }
  .arrow_box:before{
    position: absolute;
    content: "";
    border: 1px solid transparent;
    display: inline-block;
    border-width: 20px 0px 20px 20px;
    border-color: transparent transparent transparent white;
    right: -21px;
  }
  .confirm_page_button{
    width: 5rem;
  }
  .breadcrumb button{
    color:white;
    margin-top: 2px;
  }
  .breadcrumb button.active{
    background-color: #151d66;
    border: none;
    font-weight: bold;
  }
  .breadcrumb button.disable{
    background-color: rgb(54,62,110);
    color: rgb(72,92,146);
    border: none;
    cursor:inherit;
  }

  .breadcrumb{
    background-color: lighten(#151d66, 10%);
  }

  .footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #fff;
    background-color: #151d66;
    .footer-container {
      padding: 5px;
      height: 36px;
    }
  }

  .total_price{
    float: left;
    text-align: left;
    margin: 12px;
  }
  .next-button{
    float: right;
    margin-right: 4px;
    width: 180px;
  }
  button.disabled{
    background-color: rgb(54,62,110);
  }
  .marquee {
    background-color: lighten(#151d66, 10%);
  }
  .uk-modal button {
    display: block;
    width: 100%;
    background-color: rgb(54,62,110);
  }
</style>
